import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router';
import { NAVIGATION_URLS } from '../utils/urls';

export const useGlobalShortcuts = () => {
    const navigate = useNavigate();
    const sequenceTimer = useRef<NodeJS.Timeout | null>(null);
    const isWaitingForG = useRef(false);

    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            // Ignore if the user is already typing in an input, textarea, or contenteditable
            const activeTag = document.activeElement?.tagName.toLowerCase();
            if (activeTag === 'input' || activeTag === 'textarea' || (document.activeElement as HTMLElement)?.isContentEditable) {
                return;
            }

            // Focus Search Bar
            if (e.key === '/') {
                e.preventDefault(); // Prevent typing '/' inside the input immediately
                const searchInput = document.getElementById('global-search-input');
                if (searchInput) searchInput.focus();
                return;
            }

            // Start 'G' sequence
            if (e.key.toLowerCase() === 'g') {
                isWaitingForG.current = true;
                if (sequenceTimer.current) clearTimeout(sequenceTimer.current);
                // Reset the sequence if the second key isn't pressed within 1000ms
                sequenceTimer.current = setTimeout(() => {
                    isWaitingForG.current = false;
                }, 1000);
                return;
            }

            // Listen for second key in sequence
            if (isWaitingForG.current) {
                if (e.key.toLowerCase() === 'r') {
                    navigate(NAVIGATION_URLS.DASHBOARD_ADMIN_RESERVATION || '/admin/reservation');
                    isWaitingForG.current = false;
                    if (sequenceTimer.current) clearTimeout(sequenceTimer.current);
                } else if (e.key.toLowerCase() === 'c') {
                    navigate(NAVIGATION_URLS.DASHBOARD_ADMIN_RESERVATION_CALENDAR || '/admin/reservation/calendar');
                    isWaitingForG.current = false;
                    if (sequenceTimer.current) clearTimeout(sequenceTimer.current);
                }
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            if (sequenceTimer.current) clearTimeout(sequenceTimer.current);
        };
    }, [navigate]);
};
